module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Клиент")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.transaction.full_name))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Сумма")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.toMoney(_vm.transaction.amount)))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Тип операции")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.transaction.transaction_type))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Дата и время")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.formatDate(_vm.transaction.datetime)))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Примечание")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.transaction.notation))])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5f75917f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/details/transaction/TransactionDetail.vue
// module id = 653
// module chunks = 0